<template>
  <div class="widM">
    <div class="marBM" style="display:flex; justify-content: space-between;align-items: center">
      <p class="fntH6 fntL bold" style="color:#2c2c2c;">{{ getTextByType(participant) }}<span style="color:#20893d;">(<em>{{ idx + 1 }}</em>명)</span></p>
      <div v-if="idx !== 0 && !disabled">
        <button
          class="NCAcmi_family_delete"
          @click="removeFamily"
        ><span class="marRS" style="color:#2c2c2c; ">삭제</span><img src="../images/btn_close.png" alt="동반가족 삭제 버튼"></button>
      </div>
    </div>
    <div class="NCAcmi_familyN padBSM NCAcmi_lineBtm">
      <div class="floL">
        <label for="NCAcmi_family_name01">이름 <span class="ico-must-astar"></span></label>
      </div>
      <div class="floR txtR">
        <div class="NCAcmi_familyN_input">
          <input
            type="text"
            id="NCAcmi_family_name01"
            name="NCAcmi_family_name01"
            @input="inputName(resIdx, $event.target.value)"
            :value="participant.name"
            :disabled="disabled"
            maxlength="50"
          />
        </div>
      </div>
    </div>
  
    <div class="NCAcmi_familyN padBSM padTSM NCAcmi_lineBtm">
      <div class="floL">
        <label for="NCAcmi_family_personal01-1">주민등록번호 <span class="ico-must-astar"></span></label>
      </div>
      <div class="floR txtR ">
        <div class="NCAcmi_familyN_num">
          <em>
            <input
              type="number"
              id="NCAcmi_family_personal01-1"
              name="NCAcmi_family_personal01-1"
              class="NCAcmi_num"
              style="width:45%"
              @input="inputJuminNumber(resIdx, 'Q014_1', $event.target)"
              :value="participant.questions['Q014_1'].raw_data"
              :disabled="disabled"
              maxlength="6"
            /><span class="disIb txtC" style="width:10%;">-</span
            ><input
              type="number"
              id="NCAcmi_family_personal01-2"
              name="NCAcmi_family_personal01-2"
              class="NCAcmi_num"
              style="width:45%; -webkit-text-security: disc;"
              @input="inputJuminNumber(resIdx, 'Q014_2', $event.target)"
              :value="participant.questions['Q014_2'].raw_data"
              :disabled="disabled"
              maxlength="7"
            />
          </em>
        </div>
      </div>
    </div>

    <!-- 여권 사본 -->
    <SurveyAttachmentFamily
      :class="{ NCAcmi_lineBtm: showPaymentForm }"
      class="NCAcmi_familyN padBSM padTSM"
      :participant="participant"
      :sq-code="'Q015'"
      :disabled="disabled"
    />

    <SurveyParticipantPayment
      v-if="showPaymentForm"
      :paymentInfo="participant.paymentInfo"
      :disabled="disabled"
      :res-idx="resIdx"
    />
  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { mapGetters } from 'vuex'
import { SURVEY, GET_DATA_IDX_BY_TYPE, REMOVE_FAMILY, ATTENDING_LIST, IS_FAMILY_NEED_PAYMENT, INFO_AVAILABLE } from '@/store/actions/survey'
import SurveyAttachmentFamily from './SurveyAttachmentFamily.vue'
import SurveyParticipantPayment from './SurveyParticipantPayment.vue'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantFamily',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachmentFamily,
    SurveyParticipantPayment,
  },
  props: {
    idx: {
      type: Number,
      required: true,
    },
    participant: {
      type: Object,
      required: true,
    },
    // disabled: {
    //   type: Boolean,
    //   default: false
    // }
  },
  computed: {
    ...mapGetters(SURVEY, {
      getResponseIdx: GET_DATA_IDX_BY_TYPE,
      attendingList: ATTENDING_LIST,
      isFamilyNeedPayment: IS_FAMILY_NEED_PAYMENT,
      infoAvailable: INFO_AVAILABLE,
    }),
    disabled() {
      return !this.infoAvailable;
    },
    resIdx() {
      return this.getResponseIdx(this.participant.type, this.participant.type_seq);
    },
    paymentInfo() {
      return this.participant.paymentInfo;
    },
    // 동반 가족 결제 폼
    showPaymentForm() {
      return this.isFamilyNeedPayment(this.participant.type_seq);
    }
  },
  methods: {
    removeFamily() {
      if(confirm(getMessage('CONFIRM_REMOVE_FAMILY'))) {
        this.$store.dispatch(`${SURVEY}/${REMOVE_FAMILY}`, this.resIdx);
      }
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey2/components/SurveyParticipantFamily.vue